import {entity} from "../../infra/api/rpc/api";
import SearchHighlightAtServer = entity.SearchHighlight;

export class SearchHighlight {
    public static from(from: SearchHighlightAtServer): SearchHighlight {
        return new SearchHighlight(
            from.key,
            from.val,
            from.matchWord,
            from.linkId
        )
    }


    constructor(public readonly key: string,
                public readonly val: string,
                public readonly matchWord: string,
                public readonly linkId: string,
    ) {
    }

}



// WEBPACK FOOTER //
// ./src/domain/model/search_highlight.ts